import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ConditionContainer = styled(Box)(() => ({}));

export const ConditionText = styled(Typography, {
    shouldForwardProp: (prop) => prop !== '$isMet',
})<{ $isMet: boolean }>(({ theme, $isMet }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    '&::before': {
        content: '""',
        display: 'inline-block',
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: $isMet ? theme.palette.primary.dark : theme.palette.error.dark,
    },
}));

export const ClickableArgument = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'component',
})<{ component?: string }>(({ theme }) => ({
    backgroundColor: '#FFE5CC',
    color: 'black',
    padding: theme.spacing(0.25, 1.5),
    borderRadius: '4px',
    border: '0.5px solid lightgray',
    cursor: 'pointer',
    fontWeight: 400,
    fontSize: '0.8rem',
    '&:hover': {
        backgroundColor: '#FFD1A6',
        textDecoration: 'none',
    },
}));

export const RegularArgument = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'component',
})<{ component?: string }>(({ theme }) => ({
    backgroundColor: '#C4F2F2',
    color: 'black',
    padding: theme.spacing(0.25, 1.5),
    borderRadius: '4px',
    border: '0.5px solid lightgray',
    fontWeight: 400,
    fontSize: '0.8rem',
}));

export const PromptOverrideBox = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey[300]}`,
}));

export const PromptOverrideText = styled(Typography)(() => ({
    fontFamily: 'monospace',
    whiteSpace: 'pre-wrap',
}));
